import React from 'react';
import { Box } from '@material-ui/core';
import AlumniLinks from './SeniorInformationComponents/AlumniLinks.jsx';

const AlumniTipsAndLinks = () => {
  return (
    <Box sx={{ width: '100%' }}>
      <AlumniLinks />
    </Box>
  );
};

export default AlumniTipsAndLinks;
